import React, { useState } from 'react';

import { notification } from 'antd';
import * as Yup from 'yup';

import { getMoment } from '@libs/NwMoment';
// import { ListContext } from "@contexts/ListContext";
import { getNow, getTime, isAllDay } from '@libs/NwMoment';

import { useSaveAddressOnContact } from '@hooks/API/Contact/UseContactConnections';
import { getContactName } from '@hooks/API/Contact/UseContactsList';
import { useUpdateScoutingMeeting, useAddScoutingMeeting } from '@hooks/API/Event/UseScoutingMeeting';

import EditEvent from '@components/EventDrawer/EditEvent';
import {
    NWInput,
    NWContactDropdown,
    NWLocationSelector,
    NWTextAreaCharCounter,
    NWLongEventPeriodPicker,
} from '@components/Gui/NwForm/NwFormItems';

const ScoutingMeetingForm = ({
    scoutingMeetingsData,
    travelPlanId,
    viewMode,
    contactId,
    allDay,
    dateSelected,
    afterUpdate,
    //onTouchForm,
    onCancel,
    onUpdateScoutingMeetingData,
}) => {
    const [touchForm, setTouchForm] = useState(false);

    const { mutateAsync: onAddScoutingMeeting } = useAddScoutingMeeting();
    const { mutateAsync: onUpdateScoutingMeeting } = useUpdateScoutingMeeting();

    // indirizzo da salvare anche sull'anagrafica del contatto, se l'utente lo chiede
    const [addLocationToCustomer, setAddLocationToCustomer] = useState(null);
    const saveAddressOnContact = useSaveAddressOnContact();

    const fields = [
        {
            component: NWContactDropdown,
            label: 'Contact',
            activeTypes: ['cli', 'age'],
            activableTypes: [],
            name: 'ContactID',
            Col: 24,
            onAfterChange: (values, setFieldValue, value) => {
                if (value) {
                    setFieldValue('Title', `meeting with ${getContactName(value)}`);
                }
            },
        },
        {
            component: NWLongEventPeriodPicker,
            label: 'Event Period',
            name: 'EventDate',
            singleDay: true,
            Col: 24,
        },
        {
            component: NWInput,
            label: 'Title',
            name: 'Title',
            type: 'text',
            Col: 24,
        },
        {
            component: NWLocationSelector,
            name: 'Address',
            eventType: 'meeting',
            customerId: 'ContactID',
            clearOnChange: scoutingMeetingsData ? false : true,
            addLocationToCustomer: addLocationToCustomer,
            setAddLocationToCustomer: setAddLocationToCustomer,
            Col: 24,
        },
        {
            component: NWTextAreaCharCounter,
            label: 'Description',
            name: 'Description',
            type: 'text',
            maxLength: 2000,
            Col: 24,
        },
    ];

    const dataSource = contactId ? fields.filter((field) => field.name !== 'ContactID') : [...fields];

    let initialValues = {
        TravelPlanID: travelPlanId,
        Title: scoutingMeetingsData ? scoutingMeetingsData.Title : '',
        Description: scoutingMeetingsData ? scoutingMeetingsData.Description : '',
        ContactID: scoutingMeetingsData ? scoutingMeetingsData.ContactID : contactId ? contactId : '',
        Address: {
            City: scoutingMeetingsData ? scoutingMeetingsData.City : '',
            Zip: scoutingMeetingsData ? scoutingMeetingsData.Zip : '',
            Country: scoutingMeetingsData ? scoutingMeetingsData.Country : '',
            County: scoutingMeetingsData ? scoutingMeetingsData.County : '',
            State: scoutingMeetingsData ? scoutingMeetingsData.State : '',
            Access: scoutingMeetingsData ? scoutingMeetingsData.Access : '',
            Street: scoutingMeetingsData ? scoutingMeetingsData.Street : '',
        },
        EventDate: {
            startDate: scoutingMeetingsData
                ? getMoment(scoutingMeetingsData.StartDate).startOf('day')
                : dateSelected
                  ? getMoment(dateSelected).startOf('day')
                  : getNow(true),
            endDate: scoutingMeetingsData
                ? getMoment(scoutingMeetingsData.EndDate).startOf('day')
                : dateSelected
                  ? getMoment(dateSelected).startOf('day')
                  : getNow(true),
            startTime: scoutingMeetingsData
                ? getTime(getMoment(scoutingMeetingsData.StartDate))
                : dateSelected
                  ? allDay
                      ? [0, 0]
                      : getTime(dateSelected)
                  : [9, 0],
            endTime: scoutingMeetingsData
                ? getTime(getMoment(scoutingMeetingsData.EndDate))
                : dateSelected
                  ? allDay
                      ? [23, 59]
                      : getTime(dateSelected.clone())
                  : [9, 0],
            allDay: scoutingMeetingsData
                ? isAllDay(getMoment(scoutingMeetingsData.StartDate), getMoment(scoutingMeetingsData.EndDate))
                : allDay || false,
            dates: [],
        },
    };

    const submitForm = async (values, setStatus, setSubmitting) => {
        const addressOnContactError = await saveAddressOnContact({
            addLocationToCustomer,
            address: values.Address,
        });
        if (addressOnContactError) {
            notification.error({ message: 'Error', description: addressOnContactError });
        }

        const newScoutingMeetingData = {
            ...values,
            StartDate: getMoment(values.EventDate.startDate)
                .hour(values.EventDate.startTime[0])
                .minute(values.EventDate.startTime[1]),
            EndDate: getMoment(values.EventDate.endDate)
                .hour(values.EventDate.endTime[0])
                .minute(values.EventDate.endTime[1]),
            City: values.Address.City,
            Zip: values.Address.Zip,
            Country: values.Address.Country,
            County: values.Address.County,
            State: values.Address.State,
            Access: values.Address.Access,
            Street: values.Address.Street,
        };

        if (!scoutingMeetingsData) {
            try {
                const response = await onAddScoutingMeeting({ scoutingMeetingData: newScoutingMeetingData });
                setTouchForm(false);
                if (afterUpdate) {
                    afterUpdate({
                        ...response,
                        TypeName: 'Meeting',
                    });
                }
                onUpdateScoutingMeetingData(response.ID);
                onCancel();
            } catch (error) {
                console.error('ant : Create ScoutingMeeting Error', error);
            }
            setSubmitting(false);
        } else {
            newScoutingMeetingData.ID = scoutingMeetingsData.ID;
            try {
                await onUpdateScoutingMeeting({ scoutingMeetingData: newScoutingMeetingData });
                if (afterUpdate) {
                    afterUpdate();
                }
                setTouchForm(false);
                onUpdateScoutingMeetingData();
                if (!viewMode || viewMode === 'create') {
                    onCancel();
                }
            } catch (error) {
                console.error('ant : Update ScoutingMeeting Error', error);
            }
            setSubmitting(false);
        }
    };

    let validationSchema = Yup.object().shape({
        ContactID: Yup.string().required('Contact is required'),
        Title: Yup.string().required('Title is required'),
    });

    return (
        <EditEvent
            submitForm={submitForm}
            validationSchema={validationSchema}
            dataSource={dataSource}
            initialValues={initialValues}
            //disableReinitialize
            onTouchForm={setTouchForm}
            onCancel={onCancel}
        />
    );
};

export default ScoutingMeetingForm;
